export const MENTORS_RESET_STATE = 'MENTORS_RESET_STATE';
export const MENTORS_CURRENT_ITEM = 'MENTORS_CURRENT_ITEM';

export const MENTORS_REQUEST_LOADING = 'MENTORS_REQUEST_LOADING';
export const MENTORS_REQUEST_SUCCESS = 'MENTORS_REQUEST_SUCCESS';
export const MENTORS_REQUEST_FAILED = 'MENTORS_REQUEST_FAILED';

export const MENTORS_CURRENT_ACTION = 'MENTORS_CURRENT_ACTION';
export const MENTORS_RESET_ACTION = 'MENTORS_RESET_ACTION';